// extracted by mini-css-extract-plugin
module.exports = {"root":"TextLink_root__pgFT4","variant_green":"TextLink_variant_green__1Icrz","variant_white-50p":"TextLink_variant_white-50p__NAXDb"};